/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerModuleStatus200,
  GetLedgerModuleStatus404,
  GetLedgerModuleStatus500,
} from '../types/GetLedgerModule'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerModule } from '../clients/getLedgerModule'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerModuleQueryKey = () => [{ url: '/v1/ledger/module' }] as const

type GetLedgerModuleQueryKey = ReturnType<typeof getLedgerModuleQueryKey>

export function getLedgerModuleQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerModuleQueryKey()
  return queryOptions<
    GetLedgerModuleStatus200,
    ResponseErrorConfig<GetLedgerModuleStatus404 | GetLedgerModuleStatus500>,
    GetLedgerModuleStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerModule({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get the entire module object, including unborrowed leverage assets and total leverage trackers
 * {@link /v1/ledger/module}
 */
export function useGetLedgerModule<
  TData = GetLedgerModuleStatus200,
  TQueryData = GetLedgerModuleStatus200,
  TQueryKey extends QueryKey = GetLedgerModuleQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerModuleStatus200,
        ResponseErrorConfig<GetLedgerModuleStatus404 | GetLedgerModuleStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getLedgerModuleQueryKey()

  const queryResult = useQuery(
    {
      ...getLedgerModuleQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetLedgerModuleStatus404 | GetLedgerModuleStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
